import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';
import ProfileIcon from '../../../assets/icons/Profile.svg';
import EditProfileIcon from '../../../assets/icons/EditProfile.svg';
import ChangePasswordIcon from '../../../assets/icons/ChangePasswordIcon.svg';
import UpdateSecurityIcon from '../../../assets/icons/UpdateSecurity.svg';
import MFAReConfigureIcon from '../../../assets/icons/MFAReConfigureIcon.svg';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../auth/AuthContext';
import UserService from '../../../services/UserService';
import AlertService from '../../../services/AlertService';
import MaleIcon from '../../../assets/icons/Man.svg';
import WomanIcon from '../../../assets/icons/Woman.svg';
import { Skeleton } from 'primereact';

const Profile = () => {
    const navigate = useNavigate();
    const [displayName, setDisplayName] = useState();
    const [email, setEmail] = useState();
    const [mobileNo, setMobileNo] = useState();
    const [profileImage, setProfileImage] = useState();
    const [loading, setLoading] = useState(false);

    const authContext = useContext(AuthContext);

const loadUserInfo = useCallback(async (signal) => {
    setLoading(true);
    try {
      const data = await UserService.GetProfile(
        authContext,
        signal 
      );

      if (signal?.aborted) return; 

      if (data.isSuccess) {
        setDisplayName(data.data.displayName);
        setEmail(data.data.email);
        setMobileNo(data.data.mobileNo);
        setProfileImage(data.data.gender === 'F' ? WomanIcon : MaleIcon);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return;
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext]);

useEffect(() => {
    const controller = new AbortController();
    loadUserInfo(controller.signal);
    return () => controller.abort(); 
  }, [loadUserInfo, authContext]);

    const sendMFAQR = async () => {
        setLoading(true);
        const result = await UserService.SendMFAOTP(authContext);
        if (result.isSuccess) {
            setLoading(false);
            navigate("/profile/configure-mfa-otp");
        } else {
            setLoading(false);
            AlertService.error(result.errorMessage);
        }
        setLoading(false);
    };

    return (
        <Fragment>
            <div className="d-flex profile container-fluid mt-4 pt-3">
                <div className='profile-left mx-auto d-none d-xl-block'>
                    <center>
                        <img src={ProfileIcon} alt='Profile' className='img-fluid'></img>
                    </center>
                </div>
                <div className='profile-right mx-auto pt-xl-5 mt-3'>
                    {loading ? (
                        <div className='mt-auto mx-auto' style={{ maxWidth: '600px' }}>
                            <center>
                                <h4>Profile</h4>
                            </center>
                            <div className="d-flex justify-content-center mb-3 mt-3">
                                <div className="relative group">
                                    <Skeleton size='9rem' shape='circle' />
                                </div>
                            </div>
                            <div className="mb-1">
                                <Skeleton width='25%' height='2rem' />
                            </div>
                            <div className="mb-4">
                                <Skeleton width='100%' height='3.5rem' />
                            </div>
                            <div className="mb-1">
                                <Skeleton width='20%' height='2rem' />
                            </div>
                            <div className="mb-4">
                                <Skeleton width='100%' height='3.5rem' />
                            </div>
                            <div className="mb-1">
                                <Skeleton width='25%' height='2rem' />
                            </div>
                            <div className="mb-4">
                                <Skeleton width='100%' height='3.5rem' />
                            </div>
                            <div className="mt-5 d-flex">
                                <Skeleton width='20%' height='2rem' />
                                <Skeleton width='25%' height='2rem' className='ms-auto' />
                            </div>
                            <div className="mt-4 mb-3 d-flex">
                                <Skeleton width='25%' height='2rem' />
                                <Skeleton width='35%' height='2rem' className='ms-auto' />
                            </div>
                        </div>) :
                        (<Form className='mt-auto mx-auto' style={{ maxWidth: '600px' }}>
                            <center>
                                <h4>Profile</h4>
                            </center>
                            <div className="d-flex justify-content-center mb-3 mt-3">
                                <div className="relative group">
                                    <img
                                        src={profileImage}
                                        alt="Profile"
                                        style={{
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            border: '4px solid white',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                            transition: 'all 0.3s ease'
                                        }}
                                        className="profile-image"
                                    />
                                </div>
                            </div>
                            <Form.Group className="mb-4">
                                <Form.Label className="d-flex align-items-center">
                                    Display Name
                                </Form.Label>
                                <Form.Control
                                    className={`custom-input custom-input-color`}
                                    type="text"
                                    disabled
                                    placeholder="Enter Display Name"
                                    value={displayName}
                                />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label className="d-flex align-items-center">
                                    Email
                                </Form.Label>
                                <Form.Control
                                    className={`custom-input custom-input-color`}
                                    type="text"
                                    placeholder="Enter Email"
                                    value={email}
                                    disabled
                                />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label className="d-flex align-items-center">
                                    Mobile Number
                                </Form.Label>
                                <Form.Control
                                    className={`custom-input custom-input-color`}
                                    type="text"
                                    placeholder="Enter Mobile Number"
                                    value={mobileNo}
                                    disabled
                                />
                            </Form.Group>
                            <div className="mt-5 mb-3 d-flex justify-content-between">
                                <button
                                    type="button"
                                    className={`btn btn-attachment p-0 malign-baseline ${loading ? "disabled" : ""}`}
                                    title="Click to edit profile"
                                    onClick={() => navigate('/profile/edit')}
                                    disabled={loading}
                                    style={{
                                        cursor: loading ? "default" : "pointer"
                                    }}
                                ><img src={EditProfileIcon} alt='' className='me-2'></img>
                                    Edit Profile
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-attachment p-0 align-baseline  ${loading ? "disabled" : ""}`}
                                    title="Click to Re-Configure MFA"
                                    onClick={() => sendMFAQR()}
                                    disabled={loading}
                                    style={{
                                        cursor: loading ? "default" : "pointer"
                                    }}
                                ><img src={MFAReConfigureIcon} alt='' className='me-2'></img>
                                    MFA Re-Configure
                                </button>
                            </div>
                            <div className="d-flex justify-content-between">
                                <button
                                    type="button"
                                    className={`btn btn-attachment p-0 align-baseline ${loading ? "disabled" : ""}`}
                                    title="Click to change password"
                                    onClick={() => navigate('/profile/change-password')}
                                    disabled={loading}
                                    style={{
                                        cursor: loading ? "default" : "pointer"
                                    }}
                                ><img src={ChangePasswordIcon} alt='' className='me-2'></img>
                                    Change Password
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-attachment p-0 align-baseline ${loading ? "disabled" : ""}`}
                                    title="Click to Update Secuity Questions"
                                    onClick={() => navigate('/profile/update-security')}
                                    disabled={loading}
                                    style={{
                                        cursor: loading ? "default" : "pointer"
                                    }}
                                ><img src={UpdateSecurityIcon} alt='' className='me-2'></img>
                                    Update Security Questions
                                </button>
                            </div>
                        </Form>)
                    }
                </div>
            </div>
        </Fragment>
    )
}

export default Profile;